import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { cancelWorkspaceClosure } from '@/api/workspaceClosure/workspaceClosureApi';
import type { WorkspaceClosure } from '@/api/workspaceClosure/workspaceClosureApi.types';
import { WORKSPACE_CLOSURE_QUERY_KEY } from '@/constants/queryKeys';

export function useCancelWorkspaceClosureMutation(): UseMutationResult<
  WorkspaceClosure,
  Error,
  void
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: cancelWorkspaceClosure,
    onSuccess: function storeCancelledClosure(workspaceClosure) {
      queryClient.setQueryData(WORKSPACE_CLOSURE_QUERY_KEY, workspaceClosure);
    },
  });
}
